import logo from 'src/images/frida_logo.png';
import styles from './Logo.module.css';

const Logo = () => <img src={logo} alt="Logo" className={styles.logo} />;

export { Logo };
